<template>
  <div>
    <left-menu-admin menuActive="0" ></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <center>
        <v-row>
           <iframe width="2500px" height="1750px" src="https://datastudio.google.com/embed/u/0/reporting/832b725e-379b-43fe-8981-a8193c2ccfe2/page/p_rpn4hpl6uc" frameborder="0" style="border:0" allowfullscreen></iframe>
        </v-row>
         </center>
      </div>
    </v-main>
  </div>
</template>
<script>
// import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
// import XLSX from 'xlsx' // import xlsx
// import moment from 'moment' // แปลง date
// import dayName from '../../../assets/master/Date/day.json'
// import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
// import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
// import { gmapApi } from 'vue2-google-maps'

export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงาน รวม',
          disabled: false,
          href: '/Dashbord/DashBoardView'
        }
      ]
    }
  },
  async mounted () {
  },
  methods: {
  }
}
</script>
<style scope>
</style>



// WEBPACK FOOTER //
// src/components/Dashbord/DashBoardAgeRangeEmp.vue